export default __webpack_public_path__ + "static/media/vip3.902515b2.gif";